import { CollectionEntity } from "@busy-human/gearbox";
export var Units;
(function (Units) {
    const WeatherStates = ['green', 'yellow', 'red'];
    let UnitStatus;
    (function (UnitStatus) {
        UnitStatus["Available"] = "available";
        UnitStatus["Assigned"] = "assigned";
        UnitStatus["Accepted"] = "accepted";
        UnitStatus["WeatherCheck"] = "weather-check";
        UnitStatus["Declined"] = "declined";
        UnitStatus["EnRoute"] = "en-route";
        UnitStatus["AtScene"] = "at-scene";
        UnitStatus["Transporting"] = "transporting";
        UnitStatus["TransportingByGround"] = "transporting-by-ground";
        UnitStatus["AtReceiving"] = "at-receiving";
        UnitStatus["EnRouteToFuel"] = "en-route-to-fuel";
        UnitStatus["LandedAtFuel"] = "landed-at-fuel";
        UnitStatus["EnRouteToBase"] = "en-route-to-base";
        UnitStatus["Cancelled"] = "cancelled";
        UnitStatus["CancelledRTB"] = "cancelled-rtb";
        UnitStatus["NoTransport"] = "flight-completed-no-transport";
        UnitStatus["PatientTransport"] = "flight-completed-patient-transport";
        UnitStatus["Delay"] = "15-minute-delay";
        UnitStatus["MaintenanceScheduled"] = "oos-maintenance-scheduled";
        UnitStatus["MaintenanceUnscheduled"] = "oos-maintenance-unscheduled";
        UnitStatus["NotScheduled"] = "oos-not-scheduled";
        UnitStatus["Decon"] = "oos-decon";
        UnitStatus["OCCAproval"] = "pending-occ-approval";
        UnitStatus["NoMedic"] = "oos-no-medic";
        UnitStatus["NoNurse"] = "oos-no-nurse";
        UnitStatus["NoProvider"] = "oos-no-provider";
        UnitStatus["NoPilot"] = "oos-no-pilot";
        UnitStatus["CrewRest"] = "oos-crew-rest";
        UnitStatus["MissedFlight"] = "missed-flight";
        UnitStatus["AbortedFlight"] = "aborted-flight";
        UnitStatus["StandbyAssigned"] = "standby-assigned";
        UnitStatus["StandbyAccepted"] = "standby-accepted";
        UnitStatus["StandbyGo"] = "standby-go";
        UnitStatus["Pending"] = "Pending";
        UnitStatus["Unknown"] = "unknown";
        UnitStatus["Rescheduled"] = "rescheduled";
    })(UnitStatus = Units.UnitStatus || (Units.UnitStatus = {}));
    Units.StatusTitleMap = {
        "Pending": "Pending",
        "available": "Available",
        "assigned": "Assigned",
        "accepted": "Accepted",
        "weather-check": "Weather Check",
        "declined": "Declined",
        "en-route": "En Route",
        "at-scene": "At Scene",
        "transporting": "Transporting",
        "transporting-by-ground": "Transporting by ground",
        'at-receiving': "At Receiving",
        "en-route-to-fuel": "En Route to Fuel",
        "landed-at-fuel": "Landed at Fuel",
        "en-route-to-base": "En Route to Base",
        "cancelled": "Cancelled",
        "cancelled-rtb": "Cancelled - RTB",
        "flight-completed-no-transport": "Flight Completed - No Transport",
        "flight-completed-patient-transport": "Flight Completed - Patient Transport",
        "15-minute-delay": "15 Minute Delay",
        "oos-maintenance-scheduled": "OOS: Maintenance - Scheduled",
        "oos-maintenance-unscheduled": "OOS: Maintenance - UnScheduled",
        "oos-not-scheduled": "OOS: Not Scheduled",
        "oos-decon": "OOS: Decon",
        "pending-occ-approval": "Pending OCC Approval",
        "oos-no-medic": "OOS: No Medic",
        "oos-no-nurse": "OOS: No Nurse",
        "oos-no-provider": "OOS: No Provider",
        "oos-no-pilot": "OOS: No Pilot",
        "oos-crew-rest": "OOS: Crew Rest",
        "missed-flight": "Missed Flight",
        "aborted-flight": "Aborted Flight",
        "standby-assigned": "Standby Assigned",
        "standby-accepted": "Standby Accepted",
        "standby-go": "Standby Go",
        [UnitStatus.Unknown]: "Unknown",
        [UnitStatus.Rescheduled]: "Rescheduled"
    };
    /** Statuses that can be used when unit is active */
    Units.ActiveStatuses = [
        UnitStatus.Assigned,
        UnitStatus.Accepted,
        UnitStatus.WeatherCheck,
        UnitStatus.Declined,
        UnitStatus.Rescheduled,
        UnitStatus.EnRoute,
        UnitStatus.AtScene,
        UnitStatus.Transporting,
        UnitStatus.TransportingByGround,
        UnitStatus.AtReceiving,
        UnitStatus.EnRouteToBase,
        UnitStatus.NoTransport,
        UnitStatus.PatientTransport,
        UnitStatus.MissedFlight,
        UnitStatus.AbortedFlight,
        UnitStatus.CancelledRTB,
        UnitStatus.Cancelled,
        UnitStatus.OCCAproval,
        UnitStatus.EnRouteToFuel,
        UnitStatus.LandedAtFuel,
        UnitStatus.StandbyAssigned,
        UnitStatus.StandbyAccepted,
        UnitStatus.StandbyGo
    ];
    /** Statuses that can be used when unit is available */
    Units.AvailableStatuses = [
        UnitStatus.Available,
        UnitStatus.MaintenanceScheduled,
        UnitStatus.MaintenanceUnscheduled,
        UnitStatus.NotScheduled,
        UnitStatus.Decon,
        UnitStatus.NoMedic,
        UnitStatus.NoNurse,
        UnitStatus.NoProvider,
        UnitStatus.NoPilot,
        UnitStatus.CrewRest,
        UnitStatus.Delay
    ];
    let UnitEndingStatus;
    (function (UnitEndingStatus) {
        UnitEndingStatus["Cancelled"] = "cancelled";
        UnitEndingStatus["NoTransport"] = "flight-completed-no-transport";
        UnitEndingStatus["PatientTransport"] = "flight-completed-patient-transport";
        UnitEndingStatus["MissedFlight"] = "missed-flight";
    })(UnitEndingStatus = Units.UnitEndingStatus || (Units.UnitEndingStatus = {}));
    Units.InFlightStatuses = [
        UnitStatus.EnRoute,
        UnitStatus.Transporting,
        UnitStatus.EnRouteToBase,
        UnitStatus.CancelledRTB,
        UnitStatus.EnRouteToFuel
    ];
    function isInFlight(status) {
        return Units.InFlightStatuses.includes(status);
    }
    Units.isInFlight = isInFlight;
    function isEndingStatus(status) {
        switch (status) {
            case UnitStatus.Cancelled:
            case UnitStatus.NoTransport:
            case UnitStatus.PatientTransport:
            case UnitStatus.MissedFlight:
                return true;
            default:
                return false;
        }
    }
    Units.isEndingStatus = isEndingStatus;
    function isOOSStatus(status) {
        switch (status) {
            case UnitStatus.MaintenanceScheduled:
            case UnitStatus.MaintenanceUnscheduled:
            case UnitStatus.NotScheduled:
            case UnitStatus.Decon:
            case UnitStatus.OCCAproval:
            case UnitStatus.NoMedic:
            case UnitStatus.NoNurse:
            case UnitStatus.NoProvider:
            case UnitStatus.NoPilot:
            case UnitStatus.CrewRest:
                return true;
            default: return false;
        }
    }
    Units.isOOSStatus = isOOSStatus;
    function UnitDefaults() {
        return {
            company: "",
            name: "",
            status: null,
            pilot: null,
            secondInCommand: null,
            ground1: null,
            ground2: null,
            med1: null,
            med2: null,
            mechanic: null,
            med1Phone: null,
            med2Phone: null,
            mechanicPhone: null,
            timestampCreated: new Date().toISOString(),
            timestampLastActive: new Date().toISOString(),
            assigned: false,
            oos: false,
            statusTimeStamp: null,
            statusChangedBy: null,
            type: null,
            liftTime: null,
            distance: null,
            aircraft: null,
            weather: 'green',
            callQueue: []
        };
    }
    Units.UnitDefaults = UnitDefaults;
    function usersInUnit(unit) {
        var ids = [];
        if (unit.pilot?.id) {
            ids.push(unit.pilot.id);
        }
        if (unit.mechanic?.id) {
            ids.push(unit.mechanic.id);
        }
        if (unit.med1?.id) {
            ids.push(unit.med1.id);
        }
        if (unit.med2?.id) {
            ids.push(unit.med2.id);
        }
        return ids;
    }
    Units.usersInUnit = usersInUnit;
    Units.uniqueFields = ["aircraft", "ground1", "ground2", "mechanicPhone", "med1", "med1Phone", "med2", "med2Phone"];
    class CollectionClass extends CollectionEntity {
        relationships;
        defaults() {
            return UnitDefaults();
        }
    }
    Units.CollectionClass = CollectionClass;
    // export const Units = new CollectionClass({ path: "/Units" });
})(Units || (Units = {}));
//# sourceMappingURL=index.js.map